module.exports = __webpack_public_path__ + "img/cause3Green.f53afd60.png";